import { createAxiosClient, createAxiosInstance } from "./helpers";
import { DEMO_API_URL, DEV_API_URL, PRODUCTION_API_URL, STAGING_API_URL, QA_API_URL } from "./urls";
import { Environment } from "../globalTypes";
import { ClientAxiosInstance, ClientConfiguration } from "./types";
import { LocalStorageKeys } from "../../config";

const URL_ENVIRONMENT_URLS = {
  [Environment.PRODUCTION]: PRODUCTION_API_URL,
  [Environment.DEMO]: DEMO_API_URL,
  [Environment.STAGING]: STAGING_API_URL,
  [Environment.DEVELOPMENT]: DEV_API_URL,
  [Environment.QA]: QA_API_URL,
};

const coreApiConfig = (): ClientConfiguration => {
  let currentEnvironment = localStorage.getItem(LocalStorageKeys.ENVIRONMENT);

  if (currentEnvironment === "null" || !currentEnvironment) currentEnvironment = Environment.PRODUCTION;

  return {
    baseURL: URL_ENVIRONMENT_URLS[currentEnvironment],
    headers: {
      Accept: "application/json",
    },
  };
};

export const coreInstance = () => createAxiosInstance(coreApiConfig());

export const getClient = (): ClientAxiosInstance => createAxiosClient(coreInstance());

export default getClient;
